module.exports = __webpack_public_path__ + "f12a1c58eb0dff935d65e12f7c82ec5a.png";